import { AppStoreImage, DSNameLogoInMobile, DSRatings, GooglePlayStoreImage } from "../../../utils/constant";

const AppDownloadSection = () => {
  return (
    <div className="tw-mb-[56px]">
      <div className="tw-mx-auto tw-my-14 tw-flex tw-max-w-[980px] tw-justify-between tw-rounded-3xl tw-border-2 tw-border-solid tw-border-black tw-border-opacity-10 tw-px-16 tw-pt-16">
        <section>
          <div className="tw-mb-5">
            <span className="tw-flex tw-font-jakarta tw-text-xl tw-font-normal">
              All in one eCommerce management solution
            </span>
          </div>
          <div className="tw-mb-16 tw-flex tw-flex-col tw-font-jakarta tw-text-4xl tw-font-normal tw-leading-[52px]">
            <span className="tw-font-bold">Start, Manage & Scale</span>
            <span className="">your business with</span>
            <span>Digital Showroom App</span>
          </div>
          <div className="tw-mb-16 tw-flex tw-items-center tw-gap-4">
            <div className="tw-flex tw-gap-2.5">
              <img src={GooglePlayStoreImage} height={40} />
              <img src={AppStoreImage} height={40} />
            </div>
            <div className="tw-flex tw-items-center tw-justify-center">
              <img src={DSRatings} height={40} />
            </div>
          </div>
        </section>
        <section>
          <div className="tw-flex">
            <img src={DSNameLogoInMobile} height={370} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default AppDownloadSection;
